import React from 'react';
import Spinner from 'js/components/spinner/spinner';

const RandomLoadingMessage = ({ messages }) => {
    const randomMessage =
        messages[Math.round(Math.random() * (messages.length - 1))];

    return (
        <Spinner
            size="large"
            message={randomMessage}
            color={['gray', 'dark']}
            isCentered
        />
    );
};

export default RandomLoadingMessage;
